import { dashboardRouteParams } from "@/lib/dashboard-routes";

export const DEFAULT_GITHUB_INSTANCE_SLUG = "github";

export interface NamedOrg {
  orgName: string;
  instanceSlug: string;
}

const ORG_INSTANCE_KEY = "blacksmith_org_instance:";

function rememberOrgInstance(orgName: string, instanceSlug: string) {
  try {
    window.sessionStorage.setItem(
      ORG_INSTANCE_KEY + orgName.toLowerCase(),
      instanceSlug,
    );
  } catch {
    // Explicit instance URLs still work when storage is unavailable.
  }
}

export function urlInstanceSlug(
  pathname?: string,
  search?: string,
  defaultInstanceSlug?: string | null,
): string {
  const fallback = defaultInstanceSlug || DEFAULT_GITHUB_INSTANCE_SLUG;
  if (typeof window === "undefined") return fallback;
  const url = new URL(window.location.href);
  if (pathname !== undefined) url.pathname = pathname;
  if (search !== undefined) url.search = search;
  const instance = url.searchParams.get("instance");
  const routeOrg = url.pathname.startsWith("/admin/internal-monitors")
    ? undefined
    : dashboardRouteParams(url.pathname)?.org;
  const org = typeof routeOrg === "string" ? routeOrg : "";
  if (instance) {
    if (org) rememberOrgInstance(org, instance);
    return instance;
  }
  try {
    return (
      window.sessionStorage.getItem(ORG_INSTANCE_KEY + org.toLowerCase()) ||
      fallback
    );
  } catch {
    return fallback;
  }
}

/** Backend redirect that installs the GitHub App on the given instance
 * (github.com or a GHES host). Without a slug the backend picks the user's
 * only linked instance. */
export function githubAppInstallUrl(instanceSlug?: string | null): string {
  const query = instanceSlug
    ? `?instance=${encodeURIComponent(instanceSlug)}`
    : "";
  return `${process.env.NEXT_PUBLIC_API_URL}/github/install${query}`;
}

const GITHUB_ORG_PATH = /^(.*\/)?user\/github\/orgs\//;

export function scopeOrgApiPath(
  path: string,
  defaultInstanceSlug?: string | null,
): string {
  const slug = urlInstanceSlug(undefined, undefined, defaultInstanceSlug);
  if (slug === DEFAULT_GITHUB_INSTANCE_SLUG) return path;
  return path.replace(
    GITHUB_ORG_PATH,
    `$1user/${encodeURIComponent(slug)}/orgs/`,
  );
}
